import React, {useMemo} from 'react';
import styled, {useTheme} from "styled-components";
import {useTranslation} from "react-i18next";
import CustomClanFilter from "./CustomClanFilter";
import CustomClanCardTable from "./CustomClanCardTable";
import useClanApi from "../../common/hooks/clan/useClanApi";
import {FlexBox, MarginBox} from "../ui/styled";
import KoreanAd from "../ad/KoreanAd";
import {customTagStringToNumber} from "./function/customClanFunction";
import useStateWithGa4 from "../../common/hooks/useStateWithGa4";
import {ga4SendOnce} from "../../function";
import UseDispatchState from "../../common/hooks/useDispatchState";
import {
    SET_AGE_FILTER,
    SET_CLAN_MODE,
    SET_GAME_MODE,
    SET_PAGE_VALUE,
    SET_PLAYER_FILTER,
    SET_SERVER_MODE
} from "../../store/reducer/connect";

const Wrapper = styled.div`
  width: 100%;
`;
const ClanCountBox = styled.div`
  margin-top: 8px;
  margin-bottom: 16px;
`;


const funcServerFilteredList = ({list, filter}) => {
    if (typeof filter?.value === 'undefined') {
        return list
    } else if (filter.value === 0) {
        return list
    } else {
        const filteredList = list.filter((data) => data.server_type === filter.value)
        return filteredList
    }
}
const funcPlayerFilteredList = ({list, filter}) => {
    if (filter.length === 0) {
        return list;
    }
    if (filter.value === 1) {
        const filtered = list.filter((data) => data.server_scale === 1)
        return [...filtered]
    } else if (filter.value === 2) {
        const filtered = list.filter((data) => data.server_scale === 2)
        return [...filtered]
    } else if (filter.value === 3) {
        const filtered = list.filter((data) => data.server_scale === 3)
        return [...filtered]
    }
    return list;
}
const funcSearchFilteredList = ({list, filter}) => {
    if (filter === '') {
        return list;
    }
    const nameExr = new RegExp(`^${filter}+`, 'i')
    const data = list.filter((filterData) => {
        return nameExr.test(filterData.server_name);
    });
    return data
}

const funcTagFilteredList = ({list, filter}) => {
    const filterEmpty = filter.filter((data) => data.value);
    if (filterEmpty.length === 0) {
        return list;
    }
    return list.reduce((sum, cur) => {
        const clanMode = cur.tags;
        // const findIndex = clanMode.findIndex((data) => {
        //     return filterEmpty.some((item) => customTagStringToNumber(item.title) === data)
        // })
        // const findIndex = filterEmpty.findIndex((data) => {
        //    return clanMode.every((item) => customTagNumberToString(item) !== data)
        // })

        // if (findIndex > -1) {
        //     sum.push(cur)
        // }
        const condition = filterEmpty.every((data) => {
            return clanMode.includes(customTagStringToNumber(data.title))
        })
        if (condition) {
            sum.push(cur)
        }
        return sum;
    }, []);
}


const MoreButtonBox = styled.div`
  margin-top: 16px;
`;

const MinHeightBox = styled.div`
  min-height: 100vh;
`;

const GA4_CLICKED_EVENT = 'connect-list-clicked'
const GA4_SEARCH_EVENT = 'connect-list-search-key-pressed'

const CustomClanContent = () => {
    const PAGE_COUNT = 15
    const {list} = useClanApi();
    const [serverMode, setServerMode] = UseDispatchState({state:(state) => state.connect.serverMode, event: GA4_CLICKED_EVENT,reducer: SET_SERVER_MODE});
    const [playerFilter, setPlayerFilter] =UseDispatchState({state:(state) => state.connect.playerFilter, event: GA4_CLICKED_EVENT,reducer: SET_PLAYER_FILTER});
    const [gameModeFilter, setGameModeFilter] = UseDispatchState({state:(state) => state.connect.gameModeFilter, event: GA4_CLICKED_EVENT,reducer: SET_GAME_MODE});
    const [clanModeFilter, setClanModeFilter] = UseDispatchState({state:(state) => state.connect.clanModeFilter, event: GA4_CLICKED_EVENT,reducer: SET_CLAN_MODE});
    const [ageFilter, setAgeFilter] = UseDispatchState({state:(state) => state.connect.ageFilter, event: GA4_CLICKED_EVENT,reducer: SET_AGE_FILTER});
    const [search, setSearch] = useStateWithGa4({init: '', event: GA4_SEARCH_EVENT});
    const [pageValue, setPageValue] = UseDispatchState({state:(state) => state.connect.pageValue,reducer: SET_PAGE_VALUE});


    const filteredList = useMemo(() => {
        try {
            const serverFilteredList = funcServerFilteredList({list, filter: serverMode})
            const playerFilteredList = funcPlayerFilteredList({list:serverFilteredList, filter: playerFilter})
            const tagFilterList = funcTagFilteredList({
                list: playerFilteredList,
                filter: [clanModeFilter, ageFilter, gameModeFilter]
            })
            const searchFilteredList = funcSearchFilteredList({list: tagFilterList, filter: search})
            return searchFilteredList
        } catch (e) {
            console.log(e)
            return []
        }
    }, [list, playerFilter, gameModeFilter, clanModeFilter, ageFilter, search, serverMode])


    const slicedPage = useMemo(() => {
        try {
            const sliceArray = filteredList.slice(0, pageValue * PAGE_COUNT)
            return sliceArray
        } catch (e) {
            return []
        }
    }, [filteredList, pageValue]);
    const onChangeSearch = (value) => {
        setSearch(value)
        setPageValue(1)
    }


    return (
        <Wrapper>
            <CustomClanFilter
                serverMode={serverMode}
                setServerMode={setServerMode}
                setPageValue={setPageValue}
                search={search}
                setSearch={setSearch}
                playerFilter={playerFilter}
                setPlayerFilter={setPlayerFilter}
                gameModeFilter={gameModeFilter}
                setGameModeFilter={setGameModeFilter}
                clanModeFilter={clanModeFilter}
                setClanModeFilter={setClanModeFilter}
                ageFilter={ageFilter}
                setAgeFilter={setAgeFilter}/>
            <MarginBox margin={'8px 0 0 0'}>
                <KoreanAd/>
            </MarginBox>
            <ClanCountBox>
                <ClanCount onChangeSearch={onChangeSearch} search={search} count={list?.length ? list.length : 0}/>
            </ClanCountBox>
            <MinHeightBox onClick={() => {
                ga4SendOnce(GA4_CLICKED_EVENT)
            }}>
                <CustomClanCardTable list={slicedPage}/>
                <MoreButtonBox>
                    <CustomClanMoreButton onClick={() => setPageValue(pageValue + 1)}
                                          pageValue={pageValue * PAGE_COUNT}
                                          list={filteredList}/>
                </MoreButtonBox>
            </MinHeightBox>

        </Wrapper>
    );
};
const SearchWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 40px;
  border-radius: 99px;
  border: 1px solid ${props => props.theme.color.blue_700};
  padding: 5px 16px;
  width: 375px;
  background-color: ${props => props.theme.color.site_main_color};
`;
const SearchInput = styled.input`
  width: 100%;
  border: 0;
  background-color: transparent;
  font-size: 14px;
  color: ${props => props.theme.color.dark_100};

  &&::placeholder {
    color: ${props => props.theme.color.dark_200};
  }
`;
const CustomClanFilterSearch = ({search, setSearch}) => {
    const theme = useTheme();
    return (
        <SearchWrapper>
            <SearchInput
                value={search} onChange={(e) => setSearch(e.target.value)}
                placeholder={'서버 검색'}
            />
            <img
                src={`${theme.icon.path}/icon_search_color.svg`}
                width={18}
                height={18}
                alt={''}
            />
        </SearchWrapper>
    )
}

const MoreButtonWrapper = styled.button`
  border-radius: 4px;
  width: 100%;
  height: 64px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border: 1px solid ${props => props.theme.color.default_border_color};
  background-color: ${props => props.theme.color.site_main_color};
`;
const MoreButtonText = styled.span`
  font-weight: 500;
  font-size: 16px;
  line-height: 100%;
  color: ${props => props.theme.color.dark_100};
`;
const MoreButtonImgBox = styled.div`
  margin-left: 4px;
`;
const CustomClanMoreButton = ({onClick, list, pageValue}) => {
    const theme = useTheme();
    if (!list?.length) {
        return null
    }
    if (list?.length - pageValue < 1) {
        return null
    }
    return (
        <MoreButtonWrapper onClick={onClick}>
            <MoreButtonText>
                서버 더보기
            </MoreButtonText>
            <MoreButtonImgBox>
                <img
                    src={`${theme.icon.path}/clan/more_button.svg`}
                    width={16}
                    height={16}
                    alt={''}
                />
            </MoreButtonImgBox>
        </MoreButtonWrapper>
    )
}
const GreenBoxWrapper = styled.div`
  margin: 10px 0 20px;
  border: 1px solid ${props => props.theme.color.green_100};
  background-color: ${props => props.theme.color.green_200};
  border-radius: 6px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 50px;
  color: ${props => props.theme.color.green_100};
  font-weight: bold;
  font-size: 20px;
  white-space: pre-wrap;
  text-align: center;
  line-height: normal;
`;

const GreenBox = () => {
    const {t} = useTranslation()
    return (
        <GreenBoxWrapper>
            내전 전적을 자동으로 기록하는 모임·클랜·내전방송을 한눈에!
        </GreenBoxWrapper>
    )
}

const CountWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const ClanCountText = styled.span`
  font-weight: 600;
  font-size: 14px;
  color: ${props => props.theme.color.dark_200};
`;

const ClanCountGreenText = styled.span`
  font-weight: 600;
  font-size: 14px;
  color: ${props => props.theme.color.green_100};
`;
const ClanCountGreenButton = styled.button`
  margin-left: 16px;
  border-radius: 6px;
  padding: 0 24px;
  height: 40px;
  font-weight: 700;
  font-size: 16px;
  color: #fff;
  background-color: #1DAAAA;
  &:hover {
    background-color: #248888;
  }
`;

const ClanCount = ({search, onChangeSearch, count}) => {
    return (
        <CountWrapper>
            <FlexBox>
                <CustomClanFilterSearch search={search} setSearch={onChangeSearch}/>
                <MarginBox margin={'0 0 0 16px'}>
                    {/*<ClanCountText>*/}
                    {/*    등록된 서버 수: <ClanCountGreenText>{count}</ClanCountGreenText>*/}
                    {/*</ClanCountText>*/}
                </MarginBox>
            </FlexBox>
            <a href={'https://discord.gg/3pQGtfQMe9'} target={'_blank'}>
                <ClanCountGreenButton>
                    커넥트 서버 신청하기
                </ClanCountGreenButton>
            </a>
        </CountWrapper>
    )
}
export default CustomClanContent;